<script>
/* import { tableData } from './data-advance' */
import { mapActions } from 'vuex'
import moment from 'moment/moment'

export default {
	data() {
		return {
			title: 'Email Template',
			items: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortBy: '',
			sortDesc: false,
			fields: [
        { label: 'Language', key:"lang",
         formatter: (val) => {
          if(typeof val == 'object' &&  val != undefined)
            return val.text

          let ret = ''
          for(var key in this.lang_options){
            if(this.lang_options[key].value == val){
              ret = this.lang_options[key].text
              break
            }
          }
          return ret
        }},
				{ label: 'Title', key:"title"},
				{ label: 'Subject', key:"subject"},
        { label: 'Type', key:"type",
        formatter: (val) => {
          if(typeof val == 'object')
            return val.text

          let ret = ''
          for(var key in this.type_options){
            if(this.type_options[key].value == val){
              ret = this.type_options[key].text
              break
            }
          }
          return ret
        }},
        { label: 'Date Created', key:'date_created', formatter: (val) => {
          return moment(val).format('YYYY-MM-DD')
        }},
        {
          key:'actions',
          label:''
        }
      ],
      type_options: [
        { value: '', text: 'Please select a Type' },
        { value: '1', text: 'Another Interview Email', variables:['company_name', 'candidate', 'url']},
        { value: '2', text: 'Candidate Consent', variables:['candidate', 'url'] },
        { value: '3', text: 'Company Portal Link', variables:['candidate', 'url']},
        { value: '4', text: 'Confirm Account', variables:['name', 'url']},
        { value: '5', text: 'Confirm Salary Offer', variables:['candidate', 'job_reference_no', 'job_title', 'offer_salary', 'offer_description', 'url']},
        { value: '6', text: 'Confirmed Schedule by Candidate', variables:['candidate', 'job_reference', 'job_title', 'date_of_interview']},
        { value: '7', text: 'Confirmed Schedule by Candidate for Company', variables:['company', 'candidate', 'job_reference_no', 'job_title', 'date_of_inteview']},
        { value: '8', text: 'Invitation Email', variables:['name', 'url']},
        { value: '9', text: 'Job Application', variables:['company_name', 'job', 'reference_no', 'url']},
        { value: '10', text: 'Job Application Rejected', variables:['job', 'reference_no']},
        { value: '11', text: 'Re-Schedule of Interview Email', variables:['company_name', 'candidate', 'url']},
        { value: '12', text: 'Schedule Interview', variables:['candidate', 'location', 'interview_type', 'timezone', 'reference_no', 'url']},
        { value: '13', text: 'Accepted Candidate Consent', variables:['candidate', 'job_title', 'company_name', 'recruited'] },
        { value: '14', text: 'Declined Candidate Consent', variables:['candidate', 'job_title', 'company_name', 'recruited'] },
        { value: '15', text: 'Success: Upload Candidate - Sent to Admin', variables:['email', 'candidate', 'job_title', 'company_name']},
        { value: '16', text: 'Error: Upload Candidate - Sent to Admin', variables:['email', 'candidate', 'job_title', 'company_name']},
        { value: '17', text: 'Success: Upload Candidate - Sent to Recruiter', variables:['email', 'candidate', 'job_title', 'company_name']},
        { value: '18', text: 'Error: Upload Candidate - Sent to Recruiter', variables:['email', 'candidate', 'job_title', 'company_name']},
        { value: '19', text: 'Consent Acknowledged by Candidate', variables:['email', 'candidate', 'job_title', 'company_name']},
        { value: '20', text: 'Consent Rejected by Candidate', variables:['email', 'candidate', 'job_title', 'company_name']},
        { value: '21', text: 'Reset Email', variables:['email', 'link']},
        { value: '22', text: 'Candidate Application', variables:['job_title', 'candidate_name', 'candidate_email', 'candidate_no', 'company_name']}
      ],
      lang_options: [
        { value: 'all', text: 'All' },
        { value: 'jp', text: 'Japanese'},
        { value: 'us', text: 'English (US)'}
      ],
      isBusy:false
		}
	},
	computed: {
		rows() {
			return this.totalRows
		},
	},
	mounted() {
    this.fetchData()
	},
	methods: {
		...mapActions('email_template', ['pagination']),
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    async fetchData() {
      if(this.role_modules.some(item => item.value == 'email')){
        this.toggleBusy()
  
        await this.pagination({
          limit:this.perPage,
          start:this.currentPage,
        })
        .then(res => {
          this.totalRows = parseInt(res.data.total, 10)
          this.items = res.data.data
          this.toggleBusy()
        })
      }
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    onEdit(item){
      this.$emit('onEdit', item)
    }
  },
  filters: {
    formatdate: function (value) {
      if (!value) return ''

      return moment(value).format('YYYY-MM-DD')
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    filter: {
      handler: function() {
        console.log(this.filter)
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center dataTable_entries">
                  <span >{{$t('common.show')}}</span>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <span >{{$t('common.entries')}}</span>
                </label>
              </div>
            </div>
            <!-- Search -->
            <!-- <div class="col-sm-12 col-md-6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
            </div> -->
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :show-empty="true"
            >

              <template v-slot:cell(actions)="row" v-if="user.role.role == 'administration'">
                  <!-- <router-link
                    class="btn2 btn2-primary btn-sm mx-1"
                    tag="button"
                    :to="'/master_files/function/edit?id=' + row.item._id"
                  ><i class="uil uil-edit"></i>
                  </router-link> -->
                  <button class="btn2 btn2-primary btn-sm mx-1" 
                    @click="onEdit(row.item)" 
                    v-if="role_modules.some(item => item.value == 'email.edit')"><i class="uil uil-edit"></i></button>
              </template>

              <template v-slot:cell(name)="row">
                <div>{{row.item.name}}</div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
